export default "/images/settings-active-dark.svg?918f8030f76f481e7380bd483e433693";